interface Product {
  id: string;
  priceId: string;
  name: string;
  description: string;
  price: number;
  features: string[];
  mode: 'payment' | 'subscription';
  popular?: boolean;
  credits?: number;
}

export const products: Product[] = [
  /* 주석 처리된 요금제
  {
    id: 'prod_SCjQwEUk88mg4n',
    priceId: 'price_1RIJxdCRbNbadxj7zuOZjii9',
    name: 'INSTA CHAT : AI 대화 시뮬레이터 [VIP]',
    description: '최고의 AI 대화 경험을 위한 프리미엄 플랜',
    price: 39800,
    features: [
      '매주 350 크레딧',
      '고급 AI 응답',
      '우선 순위 지원',
      '맞춤형 대화 설정',
      '상세 분석 대시보드',
      '모든 페르소나 이용 가능',
      '이미지 전송 가능',
      '음성 메시지 전송 가능'
    ],
    mode: 'subscription',
    popular: true,
    credits: 350,
  },
  {
    id: 'prod_SCjOoTJKP3OqS4',
    priceId: 'price_1RIJw6CRbNbadxj7IeXC37gt',
    name: 'INSTA CHAT : AI 대화 시뮬레이터 [플래티넘]',
    description: '전문가를 위한 고급 기능',
    price: 19800,
    features: [
      '매주 125 크레딧',
      '고급 AI 응답',
      '우선 순위 지원',
      '모든 페르소나 이용 가능',
      '맞춤형 대화 설정',
      '기본 분석 기능',
    ],
    mode: 'subscription',
    credits: 125,
  },
  */
  {
    id: 'prod_SCjNSGZ4jfc3Ap',
    priceId: 'price_1RMzwUCRbNbadxj7sSBihYqZ',
    name: 'INSTA CHAT : AI 대화 시뮬레이터 [프리미엄]',
    description: '검열없는 최상급 AI 인공지능 탑재를 위한 플랜',
    price: 19800,
    features: [
 /*    '내 인스타에 온 메시지 확인 기능', */
      '채팅 내 사진 수신 기능',
      '800 채팅 크레딧 제공',
      '목소리 음성 듣기 가능',
      '무제한 인스타그램 계정 연결',
      '검열 없는 프리미엄급 AI 응답',
      '우선 고객센터 지원'
    ],
    mode: 'subscription',
    popular: true,
    credits: 800,
  },
  {
    id: 'prod_SCjMCaeFVXsbmC',
    priceId: 'price_1RIJtwCRbNbadxj7NJ7raNvD',
    name: 'INSTA CHAT : AI 대화 시뮬레이터 [베이직]',
    description: '시작하기 좋은 기본 플랜',
    price: 4900,
    features: [
      '200 채팅 크레딧',
      '인스타그램 계정 10개 연결 가능',
      '기본 AI 응답',
      '이메일 고객센터 지원',
      '기본 대화 설정'
    ],
    mode: 'subscription',
    credits: 200,
  }
 
];